<template>
<div id="stripe-elements">
  <form action="/" method="GET" @submit="dontSubmit">
    <div id="card-element">
    </div>

    <!-- <div id='loading-indicator' v-if="notLoadedYet">
        <div class='animation-wrap loading'>
          <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill="#90949A" d="M25 5a20.14 20.14 0 0120 17.88 2.51 2.51 0 002.49 2.26A2.52 2.52 0 0050 22.33a25.14 25.14 0 00-50 0 2.52 2.52 0 002.5 2.81A2.51 2.51 0 005 22.88 20.14 20.14 0 0125 5z"/></svg>
        </div>
      </div> -->

    <div id="payment-fields" v-bind:class="{'hidden' : !stripeLoaded}">
      <div class="line">
        <div class="input-field" id="card-number" :class="{'invalid': isError}"></div>
      </div>

      <div class="expiration-and-cvv">
        <div class="input-field" id="card-expiry" :class="{'invalid': isError}"></div>
        <div class="input-field" id="card-cvc" :class="{'invalid': isError}"></div>
      </div>
    </div>

    <div id="gateway-desc">
      <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" v-bind:class="'icon'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M12 4.84a3.464 3.464 0 013.464 3.464l.001 2.471A1.3 1.3 0 0116.33 12v6.062c0 .718-.581 1.3-1.299 1.3H8.97a1.299 1.299 0 01-1.3-1.3V12a1.3 1.3 0 01.867-1.225v-2.47A3.464 3.464 0 0112 4.84zm0 1.299c-1.144 0-2.08.887-2.16 2.01l-.005.155V10.7h4.33V8.304c0-1.196-.97-2.165-2.165-2.165z" fill="#2A313C" fill-rule="evenodd"/></svg>
      <span class='label'>Kartu zpracovává <a href="http://stripe.com/" target="_blank">Stripe</a>,<br>my její údaje nevidíme.</span>
    </div>

    <div id="card-errors" role="alert"></div>
  </form>
</div>
</template>

<script>
import { loadStripe } from '@stripe/stripe-js'

import Cart from '@/cart'
import Utils from '@/utils'
import PaymentService from '@/service/Payment'

export default {
  props: ['paymentOptions'],
  data() {
    return {
      Cart: Cart,
      complete: false,
      keys: {
        pk: null
      },
      stripe: null,
      elements: null,
      card: {
        number: null,
        expiry: null,
        cvc: null
      },
      stripeLoaded: true,
      cardNumberInvalid: false,
      cardExpiryInvalid: false,
      cardCvcInvalid: false,
    }
  },
  computed: {
    isError() {
      return this.$store.state.paymentValidations.isThereError
      // return this.$store.getters['paymentValidations/isFieldValid']('number')
    },
    // cardExpiryInvalid() {
    //   return this.$store.paymentValidations.isThereError
    //   // return this.$store.getters['paymentValidations/isFieldValid']('expiry')
    // },
    // cardCvcInvalid() {
    //   return this.$store.paymentValidations.isThereError
    //   // return this.$store.getters['paymentValidations/isFieldValid']('cvc')
    // },
  },
  async created() {
    this.keys.pk = this.paymentOptions.filter(option => option.option == 'STRIPE')[0].optionProperties.pk
    this.stripe = await loadStripe(this.keys.pk)
    this.elements = this.stripe.elements()
    var style = {
      base: {
        color: "#32325d",
      }
    };

    var elementStyles = {
      base: {
        color: '#FFFFFF',
        fontWeight: 500,
        fontFamily: 'Consolas, Menlo, monospace',
        fontSize: '16px',
        textAlign: 'center',
        fontSmoothing: 'antialiased',

        '::placeholder': {
          color: '#D2D5DA',
        },
        ':-webkit-autofill': {
          color: '#D2D5DA',
        },
      },
      invalid: {
        color: '#E25950',

        '::placeholder': {
          color: '#FFCCA5',
        },
      }
    };

    var elementClasses = {
      focus: 'focused',
      empty: 'empty',
      invalid: 'invalid',
    }

    this.card.number = this.elements.create("cardNumber", {
      style: elementStyles,
      placeholder: 'XXXX XXXX XXXX XXXX',
      classes: elementClasses,
    })
    this.addListener(this.card.number, 'number')

    this.card.expiry = this.elements.create("cardExpiry", {
      style: elementStyles,
      classes: elementClasses,
    })
    this.addListener(this.card.expiry, 'expiry')

    this.card.cvc = this.elements.create("cardCvc", {
      style: elementStyles,
      classes: elementClasses,
    })
    this.addListener(this.card.cvc, 'cvc')

    this.$nextTick(() => {
      this.card.number.mount('#card-number')
      this.card.expiry.mount('#card-expiry')
      this.card.cvc.mount('#card-cvc')
    })

    this.$parent.$parent.$off('submitPayment')
    this.$parent.$parent.$on('submitPayment', () => {
      console.log('Customer clicked to pay the order')
      this.pay();
    });
  },
  methods: {
    dontSubmit(event) {
      event.preventDefault()
    },
    addListener(element, field) {
      // Initial validation presumes the field is empty
      this.$store.commit({
        type: 'paymentValidations/setError',
        error: {field: field, error: 'empty'}
      })
      // Add listenr
      element.addEventListener('change', (event) => {
        if (event.error) {
          var error = event.error.message
        } else {
          var error = ''
        }
        this.$store.commit({
          type: 'paymentValidations/setError',
          error: {field: field, error: error}
        })
      })
    },
    async pay() {
      console.log('StripeElements.vue:pay()')
      const paymentAction = (await PaymentService.action('STRIPE', 'start', {}))
      const clientSecret = paymentAction.client_secret
      // console.log('StripeElements.vue:clientSecret', clientSecret)

      // console.log('confirming card payment', clientSecret, this.card)
      // console.log('scrolling up', window.scrollY)
      // window.scrollTo(0,0)
      // console.log('scrolled up', window.scrollY)

      if (!clientSecret) {
        this.$log.error({
          path: 'cart/src/components/order/paymentMethods/StripeElements',
          fn: 'pay()',
          tags: ['payment', 'triggersIntercom', 'logToCart']
        }, 'payment failed: missing client secret')
      }

      this.stripe.confirmCardPayment(clientSecret, {
        payment_method: {
          card: this.card.number,
          billing_details: {
            name: Cart.data.delivery.billing.contactName
          }
        }
      })
      .then(response => {

        // scroll to bottom - THIS IS BECAUSE FIXED ELEMENTS WEBKIT BUG ON IOS
        console.log('scrolling back down')
        Utils.scrollTo({
          targetElementId: 'final-step'
        })
        // this.Cart.globals.overlayActive = false
        if (response.error) {
          // console.error('StripeElements.vue:pay():failed', response.error.message)
          this.$log.error({
            path: 'cart/src/components/order/paymentMethods/StripeElements',
            fn: 'pay()',
            tags: ['payment', 'triggersIntercom', 'logToCart']
          }, 'payment failed', response.error.message)
          Cart.data.processingState = 'failed'
          Cart.globals.overlayActive = false
          // reset after N s
          setTimeout(() => {
            Cart.data.processingState = 'init'
          }, 3000)
        } else {
          console.log('PROCESSED')
          if (response.paymentIntent.status === 'succeeded') {
            console.log('SUCCEEDED', paymentAction.orderNumber)
            Cart.closeOrder(paymentAction.orderNumber)
          }
        }
      })
      .catch(err => {
        console.error('Error while sending payment to stripe', err)
        Cart.data.processingState = 'failed'
        Cart.globals.overlayActive = false
        // reset after N s
        setTimeout(() => {
          Cart.data.processingState = 'init'
        }, 3000)
      })
    }
  }
}
</script>

<style lang='less' scoped>
@import '../../../variables.less';

#stripe-elements {
    padding: 0 20px 20px;
    position: relative;

    #payment-fields {
        .input-field {
            height: 56px;
            background-color: @pfm-cart-color-form-bg-creditcard;
            border-radius: 7px;
            margin: 4px 0;
            padding: 18px 20px;
            color: #fff;

            &.invalid {
                border: 2px solid @pfm-cart-color-danger;
                padding: 16px 18px;
            }
        }

        .expiration-and-cvv {
            display: flex;
            flex-direction: row;

            #card-expiry {
                margin-right: 2px;
                width: 100%;
            }
            #card-cvc {
                margin-left: 2px;
                width: 100%;
            }
        }

        &.hidden {
            display: none;
        }
    }

    #gateway-desc {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        padding: 10px 0 0;

        svg.icon {
            width: 38px;
            height: 38px;

            * {
                fill: @pfm-color-neutral-800;
            }
        }

        span.label {
            color: @pfm-color-neutral-500;
            font-size: 0.8rem;
            line-height: 1rem;
            letter-spacing: 0.02rem;

            a {
                color: @pfm-color-neutral-500;

                &:hover {
                    text-decoration: underline;
                }
            }
        }
    }
}
</style>
